import { useEffect } from 'react'
import { handleClickVideoCard } from 'redux-share/actions';
import { useAppSelector } from 'redux-share/hooks';
import { shallowEqual } from 'react-redux'

const useBackButton = () => {
    useAppSelector(({ popovers: { markersListPopover, settingPopover, sharePopover, feedbackPopover, multiLivesPopover, pollPopover, autoPlayPopover, recommendListPopover, tagsPopover, speedPopover, playListPopover, playListCardPopover, commentPopover, personalMarkersPopover, bookmarksPopover, chatPopover, chatEmojisPopover, trailerPopover, loginPopover, preFactorPopover } }) => ({ markersListPopover, settingPopover, sharePopover, feedbackPopover, multiLivesPopover, pollPopover, autoPlayPopover, recommendListPopover, tagsPopover, speedPopover, playListPopover, playListCardPopover, commentPopover, personalMarkersPopover, bookmarksPopover, chatPopover, chatEmojisPopover, trailerPopover, loginPopover, preFactorPopover }), shallowEqual);
    useEffect(() => {
        const handleClickButton = () => {
            const searchParams = new URLSearchParams(window.location.search);
            const type = searchParams.get("type");
            const id = searchParams.get("id");
            handleClickVideoCard(id, type, true);
        }

        window.addEventListener('popstate', handleClickButton);
        return () => window.removeEventListener('popstate', handleClickButton);
    }, [])
}

export default useBackButton